import React from "react";

const editors = [
  {
    id: "drag",
    title: "Drag & drop editor",
    desc: "Effortlessly design beautiful emails with our simple drag-and-drop editor.",
    icon: "drag"
  },
  {
    id: "ai",
    title: "SendX AI Editor",
    desc: "A modern, block-based editor that makes writing and designing emails as seamless as typing a document.",
    icon: "ai",
    beta: true
  },
  {
    id: "html",
    title: "Plain Text / HTML editor",
    desc: "Write plain text or paste custom HTML for full control over your email design.",
    icon: "html"
  }
];

export default function TypeStep({ form, updateForm }) {
  return (
    <div className="sx-type-card">
      <h2>Select email editor</h2>

      {editors.map((editor) => (
        <button
          type="button"
          key={editor.id}
          className={`sx-editor-option ${
            form.editorType === editor.id ? "active" : ""
          }`}
          onClick={() => updateForm("editorType", editor.id)}
        >
          <div className={`sx-editor-art ${editor.icon}`}>
            {editor.icon === "drag" && (
              <div className="sx-drag-icon">
                <span></span>
                <i></i>
              </div>
            )}

            {editor.icon === "ai" && (
              <div className="sx-ai-icon">✧</div>
            )}

            {editor.icon === "html" && (
              <div className="sx-html-icon">I</div>
            )}
          </div>

          <div className="sx-editor-info">
            <h3>
              {editor.title}
              {editor.beta && <em>BETA</em>}
            </h3>

            <p>{editor.desc}</p>
            <b>→</b>
          </div>
        </button>
      ))}
    </div>
  );
}